<ng-container *transloco="let t; prefix: 'orders'">
  @for (item of sections(); track item.type) {
    <div class="order-type-header">
      <span class="title-large">{{ 'orders.ui.gestisciIlTuoOrdine' | transloco }}</span>
      <span class="order-type-chip label-large">{{ item.label }}</span>
    </div>

    <div class="order-type-code">
      <span class="body-medium">{{ item.section.codiceCliente ?? '' }}</span>
      <button mat-icon-button type="button" [attr.aria-label]="'orders.ui.modificaCodiceCliente' | transloco" (click)="editCustomerCodes()">
        <i class="fa-regular fa-pencil"></i>
      </button>
    </div>

    <div class="proposal-cards">
      <div class="proposal-card" [class.proposal-card--selected]="!!item.section.destino">
        <div class="proposal-card-icon" aria-hidden="true">
          <i [class]="(item.section.destino ? 'fa-solid' : 'fa-regular') + ' fa-truck'"></i>
        </div>

        <div class="proposal-card-info">
          <span class="title-medium-emphasized">{{ 'orders.ui.spedizione' | transloco }}</span>
          <span class="body-medium">{{ addressLabel(item.section.destino) ?? ('orders.ui.selezionaLaSpedizione' | transloco) }}</span>
          @if (hasNote(item.section.destino)) {
            <button type="button" class="proposal-card-note body-small" (click)="openNote(item.section.destino!.nota)">{{ 'orders.ui.nota' | transloco }}</button>
          }
        </div>

        <button matButton type="button" class="proposal-card-action" (click)="editShipping(item.type)">
          {{ item.section.destino ? ('orders.ui.modifica' | transloco) : ('orders.ui.aggiungi' | transloco) }}
        </button>
      </div>

      <div
        class="proposal-card"
        [class.proposal-card--selected]="!!item.section.idCodicePagamento"
        [class.proposal-card--disabled]="!item.section.destino"
      >
        <div class="proposal-card-icon" aria-hidden="true">
          <i [class]="(item.section.idCodicePagamento ? 'fa-solid' : 'fa-regular') + ' fa-credit-card'"></i>
        </div>

        <div class="proposal-card-info">
          <span class="title-medium-emphasized">{{ 'orders.ui.pagamento' | transloco }}</span>
          @if (item.section.destino) {
            <span class="body-medium">{{ paymentLabel(item.section) }}</span>
          }
        </div>

        @if (item.section.destino) {
          <button matButton type="button" class="proposal-card-action" (click)="editPayment(item.type)">
            {{ item.section.idCodicePagamento ? ('orders.ui.modifica' | transloco) : ('orders.ui.aggiungi' | transloco) }}
          </button>
        }
      </div>
    </div>
  }

  <button matButton="filled" type="button" class="proposal-continue-button" (click)="continueToSummary()">
    {{ 'orders.ui.vaiAlRiepilogo' | transloco }}
  </button>
</ng-container>
